// extracted by mini-css-extract-plugin
module.exports = {"disabled":"MainMenu_disabled__2-Hj1"};